import { createSlice } from '@reduxjs/toolkit'

/**
 * @typedef {import('../types/UserInfoData').IUserInfo} IUserInfo
 */

/**
 * @type {{isAuthenticated: boolean, userInfo: IUserInfo | null, userToken: any}}
 */
const initialState = {
    isAuthenticated: false,
    userInfo: null, // for user object
    userToken: null, // for storing the JWT
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state, action) => {
            state.userInfo = action.payload;
            state.isAuthenticated = true;
        },
        logout: (state) => {
            state.userInfo = null;
            state.isAuthenticated = false;
        }
    }
})

export const { login, logout } = authSlice.actions;
export const isAuthenticated = (state) => state.auth.isAuthenticated;
export const userInfo = authSlice;
export default authSlice.reducer;